export const POST_PAGE_TYPES = {
    INVITATIONS: 1,
    MY_POSTS: 2,
    PENDING_POSTS: 3,
};
